<template>
  <div>
    <div class="cardLayoutWrapper">
      <BasicCell
        :span="4"
        extra-class="elem--row"
      >
        <BasicCellActionIcon
          icon-name="danger"
          :deactivated="!item?.avecAlerteActionAFaire"
          :hover-messages="{ actif: 'Action en attente', inactif: 'Aucune action en attente' }"
          :is-readonly="true"
        />
        <BasicCellActionIcon
          icon-name="document-text"
          :deactivated="!item?.estSousMandatGestion"
          :hover-messages="{ actif: 'Avec mandat de gestion', inactif: 'Sans mandat de gestion' }"
          :is-readonly="true"
        />
        <BasicCellActionIcon
          icon-name="wallet"
          :deactivated="!item?.avecSubrogation"
          :hover-messages="{ actif: 'Avec subrogation', inactif: 'Sans subrogation' }"
          :is-readonly="true"
        />
      </BasicCell>
      <BasicCell
        :span="5"
        :text="codeLabel"
        lines="1"
        @click="displayDossier(item?.code as string)"
      />
      <BasicCell
        :span="10"
        :text="item?.sousDispositif ? SousDispositifLibelle[item?.sousDispositif as SousDispositif] : ''"
        lines="1"
      />
      <BasicCell
        :span="10"
        :text="item?.etablissementAdherentPrincipal?.denomination"
        lines="1"
      />
      <BasicCell :span="5">
        <BasicTooltip :label="StatutLibelle[itemStatut]">
          <BasicBadge
            :type="StatutBadgeType[itemStatut]"
            size="medium"
            :deletable="false"
            :label="StatutLibelle[itemStatut]"
          />
        </BasicTooltip>
      </BasicCell>
      <BasicCellActionIcon
        :span="1"
        icon-name="add"
        :hover-messages="{ actif: 'Créer une demande de remboursement', inactif: 'Création de DR non disponible' }"
        :deactivated="!canAddDR"
        :is-readonly="!canAddDR"
        @click="() => addDemandeDR(item)"
      />
      <BasicCellActionIcon
        :span="1"
        icon-name="eye"
        :hover-messages="{ actif: 'Consulter la demande' }"
        @click="() => displayDossier(item?.code as string)"
      />
    </div>
    <Transition name="open">
      <div
        v-if="showDrawer && stagiairesList.length"
        class="listDrawerWrapper"
      >
        <div class="content">
          <ListDetails>
            <template #content>
              <div
                class="listDetailsElement"
                v-if="stagiairesList.length"
              >
                <span class="listDetailsTitle">Stagiaire(s)</span>
                <span class="listDetailsSubtitle">
                  {{ stagiairesList }}
                </span>
              </div>
            </template>
          </ListDetails>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
  import type { RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import { SousDispositif, SousDispositifLibelle } from '@/features/domaine/types/opco/Demande/OUTILFPE'
import { type Statut, StatutBadgeType, StatutLibelle } from '@/features/domaine/types/opco/Dossier'
import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'
import BasicCellActionIcon from '@designSystem/components/basic/cell/BasicCellActionIcon.vue'
import { computed, ref } from 'vue'
import { useRechercheDossierTtActions } from '../useRechercheDossierTtActions'
import ListDetails from './ListDetails.vue'

  const { displayDossier, addDemandeDR } = useRechercheDossierTtActions()

  const props = defineProps<{ item: RechercheResultDTO }>()
  const showDrawer = ref(false)

  const codeLabel = computed(() => {
    const code = props.item?.code ?? ''
    const ref = props.item?.referenceFormationInterneEntreprise
    return ref ? `${code} (${ref})` : code
  })

  const canAddDR = computed(() => props.item.niveauPermissionDr === 'Ecriture')

  const stagiairesList = computed(() => {
    const stagiaires = props.item?.stagiaires
    if (!stagiaires || stagiaires.length === 0) return []

    return stagiaires
      .map((stagiaire) => {
        return (stagiaire.prenom ?? '') + ' ' + (stagiaire.nom ?? '')
      })
      .join(', ')
  })

  const itemStatut = computed<Statut>(() => {
    if (props.item?.statut) {
      return props.item?.statut as Statut
    }
    return 'Transmis'
  })
</script>

<style scoped>
  @import '../../index.less';
</style>
